import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Languages } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <Languages className="h-4 w-4" />
          {t(`languages.${i18n.language}`)}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => changeLanguage('de')}
          className={i18n.language === 'de' ? 'bg-accent' : ''}
        >
          {t('languages.de')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('en')}
          className={i18n.language === 'en' ? 'bg-accent' : ''}
        >
          {t('languages.en')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('fr')}
          className={i18n.language === 'fr' ? 'bg-accent' : ''}
        >
          {t('languages.fr')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('es')}
          className={i18n.language === 'es' ? 'bg-accent' : ''}
        >
          {t('languages.es')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('it')}
          className={i18n.language === 'it' ? 'bg-accent' : ''}
        >
          {t('languages.it')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('pt')}
          className={i18n.language === 'pt' ? 'bg-accent' : ''}
        >
          {t('languages.pt')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('pl')}
          className={i18n.language === 'pl' ? 'bg-accent' : ''}
        >
          {t('languages.pl')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('cs')}
          className={i18n.language === 'cs' ? 'bg-accent' : ''}
        >
          {t('languages.cs')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('hu')}
          className={i18n.language === 'hu' ? 'bg-accent' : ''}
        >
          {t('languages.hu')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('uk')}
          className={i18n.language === 'uk' ? 'bg-accent' : ''}
        >
          {t('languages.uk')}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => changeLanguage('ru')}
          className={i18n.language === 'ru' ? 'bg-accent' : ''}
        >
          {t('languages.ru')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;